const cards = {
    hearts: {
      1: require('./ace_of_hearts.png'),
      2: require('./2_of_hearts.png'),
      3: require('./3_of_hearts.png'),
      4: require('./4_of_hearts.png'),
      5: require('./5_of_hearts.png'),
      6: require('./6_of_hearts.png'),
      7: require('./7_of_hearts.png'),
      8: require('./8_of_hearts.png'),
      9: require('./9_of_hearts.png'),
      10: require('./10_of_hearts.png'),
      11: require('./jack_of_hearts2.png'),
      12: require('./queen_of_hearts2.png'),
      13: require('./king_of_hearts2.png'),
    },
    spades: {
      1: require('./ace_of_spades.png'),
      2: require('./2_of_spades.png'),
      3: require('./3_of_spades.png'),
      4: require('./4_of_spades.png'),
      5: require('./5_of_spades.png'),
      6: require('./6_of_spades.png'),
      7: require('./7_of_spades.png'),
      8: require('./8_of_spades.png'),
      9: require('./9_of_spades.png'),
      10: require('./10_of_spades.png'),
      11: require('./jack_of_spades2.png'),
      12: require('./queen_of_spades2.png'),
      13: require('./king_of_spades2.png'),
    },
    clubs: {
      1: require('./ace_of_clubs.png'),
      2: require('./2_of_clubs.png'),
      3: require('./3_of_clubs.png'),
      4: require('./4_of_clubs.png'),
      5: require('./5_of_clubs.png'),
      6: require('./6_of_clubs.png'),
      7: require('./7_of_clubs.png'),
      8: require('./8_of_clubs.png'),
      9: require('./9_of_clubs.png'),
      10: require('./10_of_clubs.png'),
      11: require('./jack_of_clubs2.png'),
      12: require('./queen_of_clubs2.png'),
      13: require('./king_of_clubs2.png'),
    },
    diamonds: {
      1: require('./ace_of_diamonds.png'),
      2: require('./2_of_diamonds.png'),
      3: require('./3_of_diamonds.png'),
      4: require('./4_of_diamonds.png'),
      5: require('./5_of_diamonds.png'),
      6: require('./6_of_diamonds.png'),
      7: require('./7_of_diamonds.png'),
      8: require('./8_of_diamonds.png'),
      9: require('./9_of_diamonds.png'),
      10: require('./10_of_diamonds.png'),
      11: require('./jack_of_diamonds2.png'),
      12: require('./queen_of_diamonds2.png'),
      13: require('./king_of_diamonds2.png'),
    },
    crazy_suit:{
     spades: require('./Sspade.png') ,
      clubs : require('./Sclub.png'),
      diamonds : require('./Sdiamond.png'),
      hearts: require('./Sheart.png') ,
    },
  };
  export default cards;